$(document).ready(function() {

    var highlightAllergen = function( id ) {
        $('.allergen[data-id="'+id+'"]').parent().toggleClass('active');
        $('.allergen-indicator[data-id="'+id+'"]').toggleClass('active');
    }

    $('.allergen[data-id], .allergen-indicator[data-id]').on('click', function(e) {
        e.preventDefault();
        highlightAllergen($(this).data('id'));
    });

});